/** Tipos de Essence e metadados compartilhados (sem dependências — evita ciclos). */
export type EssenceType = "power" | "vitality" | "agility" | "fortitude" | "ferocity";

export const ESSENCE_TYPES: readonly EssenceType[] = [
  "power",
  "vitality",
  "agility",
  "fortitude",
  "ferocity",
];

export const ESSENCE_COLOR: Record<EssenceType, number> = {
  power: 0xff5b6b,
  vitality: 0x5bff9a,
  agility: 0x5bd0ff,
  fortitude: 0xd8b24a,
  ferocity: 0xff9a3b,
};

/** Chave i18n do nome de cada essência. */
export const ESSENCE_I18N: Record<EssenceType, string> = {
  power: "essence.power",
  vitality: "essence.vitality",
  agility: "essence.agility",
  fortitude: "essence.fortitude",
  ferocity: "essence.ferocity",
};
